



















































































































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator'
import { QueryGoodsByCodee, QueryAllShopNameList, QuerySupplierList, UpdateGoods, QueryAllInvoiceTypeList, QueryCouponTemplateList } from '@/api'
import { Message } from 'element-ui'
import { ElForm } from 'element-ui/types/form'
import Rules from '@/utils/rules'
import { getByParentId, get, loadClassifyTree } from '@/store/classifyStore'
import { VImageUpload } from '@/components/upload'
import {getUser} from '@/store/userStore'

@Component({
  components: {
    VImageUpload,
  },
})
export default class CreateGoodsDialog extends Vue {
  private readonly couponAllowedShopId = 100009
  private couponTemplateOptions: any[] = []
  private show = false
  private goodsBannersGileList: Array<any> = []
  private goodsDescImgsGileList: Array<any> = []
  private data = {
    shopId: undefined as number | undefined,
    goodsBannersGileList: this.goodsBannersGileList,
    goodsDescImgsGileList: this.goodsDescImgsGileList,
    goodsBanners: '',
    goodsDescImgs: '',
    settlementAmount: 0,
    salesIntegral: 0,
    preferentialIntegral: 0,
    rewardIntegral: 0,
    profferValue: 0,
    capacityValue: 0,
    goodsOneClassifyId: undefined as number | undefined | null,
    goodsTwoClassifyId: undefined as number | undefined | null,
    goodsThreeClassifyId: undefined as number | undefined | null,
    invoiceType: undefined, // 发票类型
    invoiceTaxRate: undefined, // 发票税率
    distributionGoodsFlag: 0,
    specialPriceGoodsFlag: 0,
    repurchaseGoodsFlag: 0,
    wealthPayLimitEnabled: 0,
    maxWealthPayRatio: undefined,
    couponEnabled: 0,
    couponTemplateIds: [] as number[],
    deliverySupportType: 0,
    indexMainPushFlag: 0,
    indexMainPushEndTime: '',
    indexMainPushSort: 0,
    indexPreviewFlag: 0,
    indexPreviewStartTime: '',
    indexPreviewSort: 0,
  }
  private requiredRule = { required: true, message: '不能为空', trigger: 'blur' }
  private rules = {
    supplierCode: [this.requiredRule],
    shopId: [this.requiredRule],
    goodsName: [this.requiredRule],
    goodsUnit: [this.requiredRule],
    salesIntegral: [this.requiredRule],
  }
  private supplierOption: Array<any> = []
  private shopIdOption: Array<any> = []
  private invoiceTypeOption: Array<any> = []

  private  userInfo = getUser()

  get couponShopAllowed(): boolean {
    const sid = Number(this.data.shopId)
    return sid === this.couponAllowedShopId
  }

  @Watch('data.shopId')
  private onShopIdForCoupon(): void {
    if (!this.couponShopAllowed) {
      this.data.couponEnabled = 0
      this.data.couponTemplateIds = []
    }
  }

  private classifyTree(parentId: number) {
    return getByParentId(parentId)
  }

  public async created() {
    await this.loadSupplier()
    this.loadShop()
    this.loadInvoiceTypeList()
    this.couponTemplateOptions = (await QueryCouponTemplateList({ enabledOnly: true })) || []
  }

  private async loadShop() {
    const res = await QueryAllShopNameList({})
    const list = res.list
    this.shopIdOption = list.map((e: any) => {
      return { value: e.id, label: e.name }
    })

  }

  private async loadSupplier(){
     const res = await QuerySupplierList({})
    const list =  res.list
    this.supplierOption = list.map((e: any)=>{
      return {value: e.supplierCode,label:e.supplierSimpleName}
    })
  }
  private async loadInvoiceTypeList() {
    const res = await QueryAllInvoiceTypeList()
    if (res && Array.isArray(res)) {
      this.invoiceTypeOption = res
    } else if (res && res.list) {
      this.invoiceTypeOption = res.list
    }
  }
  private invoiceTypeChange(value: any) {
    // 当选择发票类型时，自动填充默认税率
    const selectedType = this.invoiceTypeOption.find((item: any) => item.typeCode === value)
    if (selectedType && selectedType.defaultTaxRate) {
      this.data.invoiceTaxRate = selectedType.defaultTaxRate
    }
  }

  private goodsOneClassifyIdChange() {
    this.data.goodsTwoClassifyId = null
    this.data.goodsThreeClassifyId = null
  }

  private goodsTwoClassifyIdChange() {
    this.data.goodsThreeClassifyId = null
  }

  @Emit('close')
  private close() {
    const f = this.$refs.form as ElForm
    f.resetFields()
    this.show = false
    this.data = {
      shopId: undefined,
      goodsBannersGileList: [],
      goodsDescImgsGileList: [],
      goodsBanners: '',
      goodsDescImgs: '',
      settlementAmount: 0,
      salesIntegral: 0,
      preferentialIntegral: 0,
      rewardIntegral: 0,
      profferValue: 0,
      capacityValue: 0,
      goodsOneClassifyId: undefined,
      goodsTwoClassifyId: undefined,
      goodsThreeClassifyId: undefined,
      invoiceType: undefined, // 发票类型
      invoiceTaxRate: undefined, // 发票税率
      distributionGoodsFlag: 0,
      specialPriceGoodsFlag: 0,
      repurchaseGoodsFlag: 0,
      wealthPayLimitEnabled: 0,
      maxWealthPayRatio: undefined,
      couponEnabled: 0,
      couponTemplateIds: [],
      deliverySupportType: 0,
      indexMainPushFlag: 0,
      indexMainPushEndTime: '',
      indexMainPushSort: 0,
      indexPreviewFlag: 0,
      indexPreviewStartTime: '',
      indexPreviewSort: 0,
    }
  }
  public async open(goodsCode: string) {
    this.show = true
    if (!get().child || get().child.length === 0) {
      await loadClassifyTree()
    }
    const result = await QueryGoodsByCodee({ goodsCode })
    this.data = result
    if (this.data.goodsBanners) {
      this.data.goodsBannersGileList = this.data.goodsBanners.split(',').map((e: string) => {
        return { url: e }
      })
    } else {
      this.data.goodsBannersGileList = []
    }
    if (this.data.goodsDescImgs) {
      this.data.goodsDescImgsGileList = this.data.goodsDescImgs.split(',').map((e: string) => {
        return { url: e }
      })
    } else {
      this.data.goodsDescImgsGileList = []
    }

    this.data.settlementAmount = this.data.settlementAmount / 100
    this.data.salesIntegral = this.data.salesIntegral / 100
    this.data.preferentialIntegral = this.data.preferentialIntegral / 100
    this.data.rewardIntegral = this.data.rewardIntegral / 100
    this.data.profferValue = this.data.profferValue / 100
    this.data.capacityValue = this.data.capacityValue / 100
    this.data.distributionGoodsFlag = this.data.distributionGoodsFlag === 1 ? 1 : 0
    this.data.specialPriceGoodsFlag = this.data.specialPriceGoodsFlag === 1 ? 1 : 0
    this.data.repurchaseGoodsFlag = this.data.repurchaseGoodsFlag === 1 ? 1 : 0
    const row: any = this.data
    row.wealthPayLimitEnabled = row.wealthPayLimitEnabled === 1 ? 1 : 0
    if (row.wealthPayLimitEnabled !== 1) {
      row.maxWealthPayRatio = undefined
    }
    row.couponEnabled = row.couponEnabled === 1 ? 1 : 0
    row.couponTemplateIds = row.couponTemplateIds || []
    const dst = row.deliverySupportType
    row.deliverySupportType = dst === null || dst === undefined || dst === '' ? 0 : Number(dst)
    row.indexMainPushFlag = row.indexMainPushFlag === 1 ? 1 : 0
    row.indexPreviewFlag = row.indexPreviewFlag === 1 ? 1 : 0
    row.indexMainPushSort = row.indexMainPushSort != null ? row.indexMainPushSort : 0
    row.indexPreviewSort = row.indexPreviewSort != null ? row.indexPreviewSort : 0

  }

  private onDistributionGoodsFlagChange(val: number) {
    if (val === 1) {
      this.data.specialPriceGoodsFlag = 0
    }
  }

  private onSpecialPriceGoodsFlagChange(val: number) {
    if (val === 1) {
      this.data.distributionGoodsFlag = 0
      this.data.repurchaseGoodsFlag = 0
    }
  }

  private onRepurchaseGoodsFlagChange(val: number) {
    if (val === 1) {
      this.data.specialPriceGoodsFlag = 0
    }
  }

  public async save() {
    const f = this.$refs.form as ElForm
    f.validate(async (success: boolean) => {
      if (!success) {
        return
      }
      const row: any = this.data
      if (row.wealthPayLimitEnabled === 1) {
        const r = Number(row.maxWealthPayRatio)
        if (!r || r < 1 || r > 100) {
          Message.warning('已开启限制抵扣，请填写 1～100 的整数占比')
          return
        }
      }

      const param: any = { ...this.data }
      if (param.wealthPayLimitEnabled !== 1) {
        param.wealthPayLimitEnabled = 0
        param.maxWealthPayRatio = null
      }
      if (param.couponEnabled === 1) {
        if (Number(param.shopId) !== this.couponAllowedShopId) {
          Message.warning(`仅店铺ID ${this.couponAllowedShopId} 可配置优惠券`)
          return
        }
        if (!param.couponTemplateIds || !param.couponTemplateIds.length) {
          Message.warning('开启优惠券后请至少选择一个券模板')
          return
        }
      } else {
        param.couponEnabled = 0
        param.couponTemplateIds = []
      }
      param.goodsBanners = param.goodsBannersGileList.map((e: any) => e.url).join(',')
      param.goodsDescImgs = param.goodsDescImgsGileList.map((e: any) => e.url).join(',')

      param.settlementAmount = param.settlementAmount * 100
      param.salesIntegral = param.salesIntegral * 100
      param.preferentialIntegral = param.preferentialIntegral * 100
      param.rewardIntegral = param.rewardIntegral * 100
      param.profferValue = param.profferValue * 100
      param.capacityValue = param.capacityValue * 100

      console.log(param)
      await UpdateGoods(param)

      Message.success('保存')
      this.close()
    })
  }
}
